import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import CustomButton from "../Common/CustomButton/CustomButton";
import "./CustomStepper.scss";
import Filter from "./Filters/Filter";
import TableSection from "./TableSection/TableSection";
import FormSection from "./FormSection/FormSection";
import ReviewSection from "./ReviewSection/ReviewSection";
import { Dialog } from "primereact/dialog";
import { useConfigStore } from "../../stores/config";
import Loader from "../Common/Loader/Loader";
import { useNegotiationsStore } from "../../stores/negotiationsStore";
export default function CustomStepper() {
	const { negotiation_id } = useParams<{ negotiation_id?: string }>();
	const navigate = useNavigate();
	const stepperRef = React.useRef<any>(null);
	const [visible, setVisible] = React.useState(false);
	const { updateConfig, data, updateNegotiation } = useNegotiationsStore();
	const fetchReports = useConfigStore((state) => state.fetchReports);
	
	useEffect(() => {
		const negId = negotiation_id ? parseInt(negotiation_id) : undefined;
		fetchReports(1, 10, negId);
	}, [fetchReports, negotiation_id]);

	const goNext = () => {
		if (stepperRef.current) {
			stepperRef.current.nextCallback();
		}
	};
	const goPrev = () => {
		if (stepperRef.current) {
			stepperRef.current.prevCallback();
		}
	};

	const handleUpdate = async () => {
		try {
			// Update the configuration
			await updateConfig();

			// If we're in a negotiation context, update the negotiation status to PREPARING
			if (negotiation_id) {
				await updateNegotiation(parseInt(negotiation_id), {
					status: "PREPARING",
				});
			}

			setVisible(true);
		} catch (error) {
			console.error(
				"Error updating configuration or negotiation status:",
				error
			);
			// Still show success dialog even if one operation fails
			setVisible(true);
		}
	};

	const handleOkClick = () => {
		setVisible(false);
		// reset the initial Data in negosiation store
		useNegotiationsStore.getState().resetInitialData();
		// Navigate to assessment if in negotiation context
		if (negotiation_id) {
			navigate(`/negotiation-packages/${negotiation_id}/assessment`);
		}
	};

	const footerContent = (
		<div className="flex justify-end">
			<CustomButton
				label="OK"
				iconsOnly={false}
				onClick={handleOkClick}
			/>
		</div>
	);

	return (
		<div className="card">
			<Stepper ref={stepperRef}>
				<StepperPanel header="Prepare Workspace">
					{/* secondary heading */}
					<div className="secondary-header">
						<p className="secondary-header-title">
							Prepare Workspace
						</p>
						<p className="secondary-header-p">
							Upload relevant supporting files and documents
						</p>
					</div>
					<div className="flex flex-column h-10rem">
						<Filter />
					</div>
					<TableSection />

					<div className="flex pt-4 gap-2 justify-end">
						<CustomButton
							label="Next"
							icon="pi pi-arrow-right"
							iconPosition="right"
							onClick={goNext}
							iconsOnly={false}
							variant="primary"
						/>
					</div>
				</StepperPanel>
				<StepperPanel header="Configure Parameters">
					{/* secondary heading */}
					<div className="secondary-header">
						<p className="secondary-header-title">
							Configure Parameters
						</p>
						<p className="secondary-header-p">
							Update configuration parameters
						</p>
					</div>
					<div className="flex flex-column h-12rem">
						{/* form section */}
						<FormSection />
					</div>
					<div className="flex pt-4 gap-2 justify-end">
						<CustomButton
							label="Back"
							variant="secondary"
							icon="pi pi-arrow-left"
							iconPosition="left"
							onClick={goPrev}
							iconsOnly={false}
						/>
						<CustomButton
							disabled={
								data.target_savings &&
								data.target_simulated_savings
									? false
									: true
							}
							label="Next"
							icon="pi pi-arrow-right"
							iconPosition="right"
							onClick={goNext}
							iconsOnly={false}
						/>
					</div>
				</StepperPanel>
				<StepperPanel header="Review and Update">
					{/* secondary heading */}
					<div className="secondary-header">
						<p className="secondary-header-title">Review</p>
						<p className="secondary-header-p">
							Review the summary and submit
						</p>
					</div>
					<div className="flex flex-column h-12rem"></div>
					<div className="flex flex-column h-12rem">
						<ReviewSection />
					</div>
					<div className="flex pt-4 gap-2 justify-end">
						<CustomButton
							label="Back"
							variant="secondary"
							icon="pi pi-arrow-left"
							iconPosition="left"
							onClick={goPrev}
							iconsOnly={false}
						/>
						<CustomButton
							disabled={
								data.target_savings &&
								data.target_simulated_savings
									? false
									: true
							}
							label="Update"
							onClick={handleUpdate}
							iconsOnly={false}
						/>
					</div>
				</StepperPanel>
			</Stepper>

			<Dialog
				header="Success Message"
				visible={visible}
				style={{ width: "25vw" }}
				footer={footerContent}
				onHide={() => {
					if (!visible) return;
					setVisible(false);
				}}
			>
				<p className="my-0 confirmation-text">
					<i className="pi pi-check mr-2"></i>
					Updated!
				</p>
			</Dialog>
			<Loader />
		</div>
	);
}
